// aldoo-ra/RBAC/roles.js
import RBAC from "./rbac"
import AdminSignIn from "aldoo-ra/Admin/Signin"
import SiteSignIn from "@components/Signin"

/**
 * Admin role wrapper - requires "role:admin" permission
 * Redirects to admin sign-in page if not authenticated
 */
export const adminRole = RBAC({
    permission: "role:admin",
    grantAt: AdminSignIn
})

/**
 * Site user role wrapper - requires "role:user" permission
 * Redirects to site sign-in dialogs if not authenticated
 */
export const siteUserRole = RBAC({
    permission: "role:user",
    grantAt: SiteSignIn
})

/**
 * Permission-based wrapper factory
 * @param {string} permission - Permission required
 * @param {Component} grantAt - Component to show if permission denied
 */
export const requirePermission = (permission, grantAt = AdminSignIn) => RBAC({
    permission,
    grantAt
})